export default "__VITE_PUBLIC_ASSET__082ef54f__"